import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AddDevice, CustomerDeviceResponse } from '@garmin-avcloud/avcloud-fly-web-common/models';
import { AdminLegacyDeviceServiceInterface } from '@garmin-avcloud/avcloud-fly-web-common/shared';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CustomerDeviceChanges } from '../../features/users/models/customer-device-changes.model';

const jsonHttpOptions = {
  headers: new HttpHeaders({
    Accept: 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class AdminLegacyDeviceService implements AdminLegacyDeviceServiceInterface {
  readonly http = inject(HttpClient);

  private readonly baseUrl = `${environment.legacyFlyAdminApi}`;

  getPortables(customerGuid: string): Observable<CustomerDeviceResponse[]> {
    const headers = jsonHttpOptions.headers.append('X-flyGarmin-Client-ID', 'FLY_ADMIN_LEGACY_APP');

    return this.http.get<CustomerDeviceResponse[]>(`${this.baseUrl}/customer/${customerGuid}/portables/`, { headers });
  }

  addPortable(device: AddDevice, customerGuid: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/customer/${customerGuid}/portables/`, device);
  }

  deletePortableDevice(customerGuid: string, deviceId: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${customerGuid}/portables/${deviceId}/`);
  }

  savePortableDeviceChanges(
    customerGuid: string,
    deviceId: number,
    deviceChanges: CustomerDeviceChanges
  ): Observable<CustomerDeviceResponse> {
    return this.http.patch<CustomerDeviceResponse>(
      `${this.baseUrl}/${customerGuid}/portables/${deviceId}/`,
      deviceChanges
    );
  }
}
